import React from 'react'
import { useSelector } from 'react-redux'
import { FaChevronRight } from 'react-icons/fa6'
import { pluralBs } from '../Utils/Helpers'

/* Overlapping logos of the portals covering a story + "N portala".
   portals: portal names, headline's portal first (from the API). */
export default function Coverage({ portals = [], articles = 1, onClick }) {
  const portalsList = useSelector((state) => state.portals.list)

  const shown = portals.slice(0, 5).map((name) => ({
    name,
    logo: portalsList?.find((p) => p.title === name)?.logo,
  }))

  const label =
    portals.length > 1
      ? `${portals.length} ${pluralBs(portals.length, 'portal', 'portala', 'portala')}`
      : `${articles} ${pluralBs(articles, 'članak', 'članka', 'članaka')}`

  return (
    <button type="button" className="coverage" onClick={onClick}>
      <span className="coverage-logos">
        {shown.map((p) =>
          p.logo ? (
            <img key={p.name} src={p.logo} alt={p.name} title={p.name} referrerPolicy="no-referrer" />
          ) : (
            <span key={p.name} className="coverage-initial" title={p.name}>
              {p.name.charAt(0)}
            </span>
          )
        )}
      </span>
      <span className="coverage-label">{label}</span>
      <FaChevronRight className="coverage-chevron" />
    </button>
  )
}
